import { noop } from 'lodash';
import { memo } from 'react';

import { type Clip } from '@air/api/types';

import { DraggingOverlay } from '~/components/Gallery/DraggingOverlay';
import { FileGalleryCard, type FileGalleryCardProps } from '~/components/Gallery/FileGalleryCard/FileGalleryCard';
import { DNDParentAsset } from '~/components/Shared/Drag/DNDParentAsset';
import DragType from '~/components/Shared/Drag/dragTypes';
import { DragDroppableFileShell, type DragDroppableFileShellProps } from '~/components/Shared/DragDroppableFileShell';
import { DropHighlight } from '~/components/Shared/DropHighlight';

export type DNDFileGalleryCardProps = {
  enableDrag?: boolean;
  index: number;
} & FileGalleryCardProps<Clip> &
  Pick<DragDroppableFileShellProps, 'onDragStart'>;

export const DNDFileGalleryCard = memo(
  ({ enableDrag = true, file, index, onDragStart = noop, ...rest }: DNDFileGalleryCardProps) => {
    return (
      <DragDroppableFileShell enabled={enableDrag} file={file} index={index} onDragStart={onDragStart}>
        <DNDParentAsset asset={file} dropLocation="file" style={{ height: '100%' }}>
          <DropHighlight borderRadius={10} />
          <FileGalleryCard {...rest} file={file} />
          <DraggingOverlay itemId={file.id} type={DragType.file} />
        </DNDParentAsset>
      </DragDroppableFileShell>
    );
  },
);

DNDFileGalleryCard.displayName = 'DNDFileGalleryCard';
